/**
 * ETA and the safety checks the form exists for: sunset and safe flight time.
 * ETA is computed un-wrapped (minutes may exceed 1440) so a flight crossing
 * midnight is detectable — the "ETA nach Sonnenuntergang" warning must never
 * be silenced by a wrap to "01:00".
 */
import { parseHM } from './parse.js';
/** ETD + total minutes → un-wrapped minutes since midnight of the departure day, or null. */
export function eta(etd, totalMin) {
    const d = parseHM(etd);
    if (!Number.isFinite(d) || totalMin === null)
        return null;
    return d + totalMin;
}
export function safetyWarnings(c) {
    const w = [];
    if (c.incompleteRoute) {
        w.push({ level: 'amber', code: 'route-incomplete',
            message: 'Mindestens ein Abschnitt hat eine Entfernung, aber keine Zeit – Gesamtzeit und ETA sind unvollständig.' });
    }
    const ss = parseHM(c.ss);
    if (c.etaMin !== null && Number.isFinite(ss)) {
        if (c.etaMin >= 1440) {
            w.push({ level: 'red', code: 'eta-next-day', message: 'ETA liegt am Folgetag – weit nach Sonnenuntergang!' });
        }
        else if (c.etaMin >= ss) {
            w.push({ level: 'red', code: 'eta-after-sunset', message: 'ETA liegt nach Sonnenuntergang!' });
        }
        else if (c.etaMin >= ss - 30) {
            w.push({ level: 'amber', code: 'eta-near-sunset', message: 'ETA liegt weniger als 30 min vor Sonnenuntergang.' });
        }
    }
    const safe = parseHM(c.safeTime);
    if (Number.isFinite(safe) && c.totalTimeMin !== null && c.totalTimeMin > safe) {
        w.push({ level: 'red', code: 'exceeds-safe-time', message: 'Gesamtflugzeit überschreitet die sichere Flugzeit!' });
    }
    return w;
}
//# sourceMappingURL=times.js.map